import { createFeatureSelector,createSelector } from '@ngrx/store';
import { TaxTypeState, TAX_TYPE_FEATURE_KEY, selectTaxTypeEntities, selectTaxTypeFetched, selectAllTaxType} from '../reducers/tax-type.reducer';

const selectState = createFeatureSelector<TaxTypeState>(TAX_TYPE_FEATURE_KEY);
export const getTaxTypeDictionary = createSelector(selectState, selectTaxTypeEntities);
// export const getTaxTypeLatestUpdatedAt = createSelector(selectState, selectTaxTypeLatestUpdatedAt);
export const getTaxTypeFetched = createSelector(selectState, selectTaxTypeFetched);
export const getTaxTypes = createSelector(selectState, selectAllTaxType);
export const getTaxTypesActive = createSelector(getTaxTypes, (activities) => activities.filter((taxType) => !taxType.DeletedAt));
export const getTaxTypeById = (props: { id: number }) => createSelector(getTaxTypeDictionary, (dictionary) => props.id && dictionary[props.id]);
